<template>
  <div>
    <v-card>
      <!--       <v-toolbar flat height="auto" class="custom-table-toolbar">
        <v-toolbar-items class="d-flex align-center" :class="{'flex-wrap': $vuetify.breakpoint.width < 1280}" style="width: 100%">
          <v-switch
            class="mr-5 mt-2 mb-3"
            v-if="enableSelectToggle"
            v-model="tableTickboxToggle"
            inset
            dense
            hide-details
            label="啟用勾選"
          ></v-switch>
          <v-switch
            class="mr-5"
            v-if="enableWeekdayToggle"
            v-model="tableWeekdayToggle"
            inset
            dense
            hide-details
            label="顯示禮拜"
          ></v-switch>
          <v-text-field
            class="mr-3 mt-2 mb-3"
            style="width: 100%; max-width: 320px"
            v-if="enableSearch"
            v-model="searchText"
            :append-icon="mdiMagnify"
            :label="searchPlaceholder"
            single-line
            outlined
            dense
            hide-details
            clearable
            @click:clear="clearSearch()"
            @click:append="clickSearch()"
            @keydown.enter="clickSearch()"
            @input="inputSearch()"
          ></v-text-field>
          <v-menu
            style="width: 100%; max-width: 320px"
            v-if="enableDateRange"
            ref="dateRangeMenu"
            v-model="dateRangeMenu"
            :close-on-content-click="false"
            :return-value.sync="searchDateRange"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                class="mr-3 mt-2 mb-3"
                style="width: 100%; max-width: 320px"
                :value="displayCustomDateRange(searchDateRange)"
                :label="dateRangePlaceholder"
                :append-icon="mdiCalendarSearch"
                single-line
                outlined
                dense
                hide-details
                clearable
                readonly
                @click:clear="clearDateRange()"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="searchDateRange"
              range
              no-title
              scrollable
              :first-day-of-week="0"
              :day-format="Formatter.dayFormat"
              locale="zh-hk"
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                small
                color="error"
                @click="dateRangeMenu = false"
              >
                <v-icon class="mr-1" small>{{ mdiClose }}</v-icon>
                取消
              </v-btn>
              <v-btn
                text
                small
                color="primary"
                @click="$refs.dateRangeMenu.save(searchDateRange);selectDateRange()"
              >
                <v-icon class="mr-1" small>{{ mdiCheck }}</v-icon>
                確定
              </v-btn>
            </v-date-picker>
          </v-menu>
          <v-select
            v-if="enableFilter"
            v-model="tableFilterModel"
            class="mr-3 mt-2 mb-3"
            style="width: 100%; max-width: 320px"
            :items="tableFilterData"
            :menu-props="{ offsetY: true }"
            outlined
            hide-details
            dense
            @change="changeFilter()"
          ></v-select>
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <v-toolbar-items class="d-flex align-center">
          <v-btn v-if="enableClearAll" text small color="error" @click="clickClearAll()" plain>
            <v-icon class="mr-1" color="error">{{ mdiClose }}</v-icon>
            清除所有搜尋
          </v-btn>
          <v-btn v-if="enableRefresh" text small color="primary" @click="clickRefresh()" :plain="!$vuetify.theme.dark">
            <v-icon class="mr-1" color="primary">{{ mdiRefresh }}</v-icon>
            重新載入
          </v-btn>
        </v-toolbar-items>
      </v-toolbar> -->
      <v-data-table
        class="custom-table"
        locale="zh-hk"
        :loading="isLoading"
        :headers="tableHeaders"
        :items="tableData"
        :items-per-page="pageLimit"
        :page="page"
        :server-items-length="itemTotal"
        :options.sync="options"
        :height="isFixedHeader ? 'calc(3.125rem * ' + (pageLimit + 1.1) + ')' : ''"
        :fixed-header="isFixedHeader"
        :show-select="enableSelectToggle && tableTickboxToggle"
        :show-expand="enableExpand"
        :show-group-by="enableGroupBy"
        :single-select="isSingleSelect"
        :single-expand="isSingleExpand"
        :hide-default-header="disableHeader"
        :hide-default-footer="disableFooter"
        :disable-filtering="disableFiltering"
        :disable-pagination="disablePagination"
        :disable-sort="disableSort"
        :multi-sort="isMultiSort"
        :must-sort="isMustSort"
        :sort-by="defaultSortKey"
        :sort-desc="defaultSortDesc"
        :header-props="{
          sortByText: '資料排序',
        }"
        :footer-props="{
          showCurrentPage: true,
          showFirstLastPage: enableFirstLastPage,
          disablePagination: disablePagination,
          itemsPerPageText: 'Rows per page:',
          itemsPerPageOptions: pageLimitOptions,
          itemsPerPageAllText: 'All',
          pageText:
            'Show ' +
            (tableData.length > 1
              ? (page - 1) * pageLimit + 1 + '-' + Math.min(page * pageLimit, itemTotal)
              : (page - 1) * pageLimit + 1) +
            ' Items',
        }"
        loading-text="Processing"
        no-data-text="No Data"
        no-results-text="No Data"
        :dense="isDense"
        :mobile-breakpoint="breakpoint"
      >
        <template v-slot:top="{ pagination, options, updateOptions }">
          <v-data-footer
            class="hide-page-select"
            :show-current-page="true"
            :disable-items-per-page="true"
            :pagination="pagination"
            :options="options"
            :show-first-last-page="enableFirstLastPage"
            :items-per-page-text="''"
            :page-text="
              'Total ' +
                (itemTotal % pageLimit == 0 ? itemTotal / pageLimit : parseInt(itemTotal / pageLimit) + 1) +
                ' pages / ' +
                itemTotal +
                ' items '
            "
            @update:options="updateOptions"
          >
          </v-data-footer>
        </template>

        <template v-slot:[`item.announcement_button`]="{ item }">
          <div class="d-flex align-center justify-space-around">
            <div>
              <router-link :to="{ name: 'editAnnouncement', params: { id: item.id } }">
                <v-btn color="accent" small>
                  {{ $t('general.edit') }}
                </v-btn>
              </router-link>
            </div>
            <div>
              <v-btn color="error" @click="removeAnnouncement(item.id)" small>
                {{ $t('general.delete') }}
              </v-btn>
            </div>
          </div>
        </template>
        <template v-slot:[`item.jobs_button`]="{ item }">
          <div class="d-flex align-center justify-space-around">
            <div>
              <router-link :to="{ name: 'editJob', params: { id: item.id } }">
                <v-btn color="accent" small>
                  {{ $t('general.edit') }}
                </v-btn>
              </router-link>
            </div>
            <div class="">
              <v-btn color="error" @click="removeJob(item.id)" small>
                {{ $t('general.delete') }}
              </v-btn>
            </div>
          </div>
        </template>
        <template v-slot:[`item.report_button`]="{ item }">
          <div class="d-flex align-center justify-space-around">
            <div>
              <router-link :to="{ name: 'editReport', params: { id: item.id } }">
                <v-btn color="accent" small>
                  {{ $t('general.edit') }}
                </v-btn>
              </router-link>
            </div>
            <div>
              <v-btn color="error" @click="removeReport(item.id)" small>
                {{ $t('general.delete') }}
              </v-btn>
            </div>
          </div>
        </template>
        <template v-slot:[`item.media_coverage_button`]="{ item }">
          <div class="d-flex align-center justify-space-around">
            <div>
              <router-link :to="{ name: 'editMediaCoverage', params: { id: item.id } }">
                <v-btn color="accent" small>
                  {{ $t('general.edit') }}
                </v-btn>
              </router-link>
            </div>
            <div>
              <v-btn small color="error" @click="removeMediaCoverage(item.id)">
                {{ $t('general.delete') }}
              </v-btn>
            </div>
          </div>
        </template>
        <template v-slot:[`item.press_release_button`]="{ item }">
          <div class="d-flex align-center justify-space-around">
            <div>
              <router-link :to="{ name: 'editPressRelease', params: { id: item.id } }">
                <v-btn color="accent" small>
                  {{ $t('general.edit') }}
                </v-btn>
              </router-link>
            </div>
            <div>
              <v-btn color="error" @click="removePressRelease(item.id)" small>
                {{ $t('general.delete') }}
              </v-btn>
            </div>
          </div>
        </template>
        <template v-slot:[`item.presentation_button`]="{ item }">
          <div class="d-flex flex-wrap align-center flex-sm-column flex-md-row flex-lg-row flex-xl-row pa-sm-2">
            <div>
              <router-link :to="{ name: 'editPresentation', params: { id: item.id } }">
                <v-btn color="accent">
                  {{ $t('general.edit') }}
                </v-btn>
              </router-link>
            </div>
            <div class="ml-xl-4 ml-lg-4 ml-md-4 mt-sm-2 mt-md-0 mt-lg-0 mt-xl-0">
              <v-btn color="error" @click="removePresentation(item.id)">
                {{ $t('general.delete') }}
              </v-btn>
            </div>
          </div>
        </template>
        <template v-slot:[`item.analyst_coverage_button`]="{ item }">
          <div class="d-flex flex-wrap align-center flex-sm-column flex-md-row flex-lg-row flex-xl-row pa-sm-2">
            <div>
              <router-link :to="{ name: 'editAnalystCoverage', params: { id: item.id } }">
                <v-btn color="accent">
                  {{ $t('general.edit') }}
                </v-btn>
              </router-link>
            </div>
            <div class="ml-xl-4 ml-lg-4 ml-md-4 mt-sm-2 mt-md-0 mt-lg-0 mt-xl-0">
              <v-btn color="error" @click="removeAnalystCoverage(item.id)">
                {{ $t('general.delete') }}
              </v-btn>
            </div>
          </div>
        </template>
        <template v-slot:[`item.investor_notices_button`]="{ item }">
          <div class="d-flex flex-wrap align-center flex-sm-column flex-md-row flex-lg-row flex-xl-row pa-sm-2">
            <div>
              <router-link :to="{ name: 'editInvestorNotices', params: { id: item.id } }">
                <v-btn color="accent">
                  {{ $t('general.edit') }}
                </v-btn>
              </router-link>
            </div>
            <div class="ml-xl-4 ml-lg-4 ml-md-4 mt-sm-2 mt-md-0 mt-lg-0 mt-xl-0">
              <v-btn color="error" @click="removeInvestorNotices(item.id)">
                {{ $t('general.delete') }}
              </v-btn>
            </div>
          </div>
        </template>
      </v-data-table>

      <SnackBar :text="snack_bar_text" :snackbar="snack_bar_open" v-on:close="updateSnackBar" />
      <Dialog :dialog.sync="dialog_open" v-on:close="getDialogValue" :text="dialog_text" />
    </v-card>
  </div>
</template>

<script>
/* eslint-disable no-else-return */
import {
  mdiEyeOutline,
  mdiTrashCanOutline,
  mdiCheckCircle,
  mdiAlert,
  mdiAlertOutline,
  mdiCancel,
  mdiCheck,
  mdiClose,
  mdiDeleteForever,
  mdiRefresh,
  mdiMagnify,
  mdiCalendarSearch,
  mdiNotePlusOutline,
} from '@mdi/js'
import Dialog from '@/components/Dialog'
import SnackBar from '@/components/SnackBar'
import { postData } from '@/api'

import { globalFunc, MEDIA_PATH } from '@/global'
export default {
  // ------ page properties ------
  name: 'CorrectTable',
  mixins: [globalFunc],
  components: {
    Dialog,
    SnackBar,
  },
  props: {
    draggable: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    tableHeaders: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    tableFilterData: {
      type: Array,
      default: () => [{ text: '全部', value: 'all' }],
    },
    itemTotal: {
      type: Number,
      default: 0,
    },
    defaultSortKey: {
      type: Array,
      default: () => ['create_date'],
    },
    defaultSortDesc: {
      type: Array,
      default: () => [true],
    },
    isSingleSelect: {
      type: Boolean,
      default: false,
    },
    isSingleExpand: {
      type: Boolean,
      default: false,
    },
    isMustSort: {
      type: Boolean,
      default: true,
    },
    isMultiSort: {
      type: Boolean,
      default: false,
    },
    isFixedHeader: {
      type: Boolean,
      default: false,
    },
    isDense: {
      type: Boolean,
      default: false,
    },
    enableSelectToggle: {
      type: Boolean,
      default: false,
    },
    enableWeekdayToggle: {
      type: Boolean,
      default: false,
    },
    enableRefresh: {
      type: Boolean,
      default: true,
    },
    enableSearch: {
      type: Boolean,
      default: false,
    },
    enableFilter: {
      type: Boolean,
      default: false,
    },
    enableDateRange: {
      type: Boolean,
      default: false,
    },
    enableClearAll: {
      type: Boolean,
      default: false,
    },
    enableExpand: {
      type: Boolean,
      default: false,
    },
    enableGroupBy: {
      type: Boolean,
      default: false,
    },
    enableFirstLastPage: {
      type: Boolean,
      default: true,
    },
    disableSort: {
      type: Boolean,
      default: false,
    },
    disableFiltering: {
      type: Boolean,
      default: false,
    },
    disableHeader: {
      type: Boolean,
      default: false,
    },
    disableFooter: {
      type: Boolean,
      default: false,
    },
    disablePagination: {
      type: Boolean,
      default: false,
    },
    pageLimitOptions: {
      type: Array,
      default: () => [5, 10, 20, 50],
    },
    page: {
      type: Number,
      default: 1,
    },
    pageLimit: {
      type: Number,
      default: 10,
    },
    breakpoint: {
      type: Number,
      default: 960,
    },
    actionViewRouteLink: {
      type: String,
      default: '',
    },
    searchPlaceholder: {
      type: String,
      default: '搜尋',
    },
    dateRangePlaceholder: {
      type: String,
      default: '按日期範圍搜尋',
    },
    confirmDeleteDes: {
      type: String,
      default: '此動作將無法還原',
    },
  },
  // ------ page variables ------
  data: () => ({
    globalFunc: globalFunc,
    MEDIA_PATH: MEDIA_PATH,
    tableInit: false,
    tableWeekdayToggle: true,
    tableTickboxToggle: false,
    tableFilterModel: 'all',
    options: {},
    searchText: '',
    searchDateRange: [],
    dateRangeMenu: false,

    // icon
    mdiEyeOutline,
    mdiTrashCanOutline,
    mdiAlertOutline,
    mdiCancel,
    mdiCheck,
    mdiClose,
    mdiDeleteForever,
    mdiRefresh,
    mdiMagnify,
    mdiCalendarSearch,
    mdiNotePlusOutline,
    mdiCheckCircle,
    mdiAlert,

    dialog_open: false,
    dialog_text: '',
    dialog_type: '',
    item_id: -1,
    snack_bar_text: '',
    snack_bar_open: false,
  }),
  // ------ mutation observer ------
  watch: {
    options: {
      handler() {
        this.updateOptions()
      },
      deep: true,
    },
  },
  // ------ life cycle events ------
  created() {},
  // ------ page functions ------
  methods: {
    displayCustomDateRange(date) {
      if (date.length === 2) {
        if (new Date(date[0]).getTime() > new Date(date[1]).getTime()) {
          return `${date[1]} (${this.Formatter.displayWeekday(date[1])}) ~ ${date[0]} (${this.Formatter.displayWeekday(
            date[0],
          )})`
        } else {
          return `${date[0]} (${this.Formatter.displayWeekday(date[0])}) ~ ${date[1]} (${this.Formatter.displayWeekday(
            date[1],
          )})`
        }
      } else if (date.length === 1) {
        return `${date[0]} (${this.Formatter.displayWeekday(date[0])})`
      }
      return ''
    },
    updateOptions() {
      if (this.tableInit) {
        this.$emit('options-update', this.options)
      }
      this.tableInit = true
    },
    clickRefresh() {
      this.$emit('refresh-clicked')
    },
    clickSearch() {
      this.$emit('search-clicked', this.searchText)
    },
    inputSearch() {
      this.$emit('search-input', this.searchText)
    },
    clearSearch() {
      this.$emit('search-cleared')
    },
    selectDateRange() {
      if (this.searchDateRange.length === 2) {
        if (new Date(this.searchDateRange[0]).getTime() > new Date(this.searchDateRange[1]).getTime()) {
          this.$emit('daterange-selected', [this.searchDateRange[1], this.searchDateRange[0]])
        } else {
          this.$emit('daterange-selected', this.searchDateRange)
        }
      } else {
        this.$emit('daterange-selected', this.searchDateRange)
      }
    },
    clearDateRange() {
      this.searchDateRange = []
      this.$emit('daterange-cleared')
    },
    clickClearAll() {
      this.searchText = ''
      this.searchDateRange = []
      this.tableFilterModel = 'all'
      this.$emit('all-search-cleared')
    },
    changeFilter() {
      this.$emit('filter-changed', this.tableFilterModel)
    },
    removeAnnouncement(id) {
      this.dialog_text = this.$t('instruction.remove_item') + ' ' + this.$t('navigation.announcement') + '?'
      this.dialog_type = 'announcement_data'
      this.item_id = id
      this.dialog_open = true
    },
    removeReport(id) {
      this.dialog_text = this.$t('instruction.remove_item') + ' ' + this.$t('navigation.report') + '?'
      this.dialog_type = 'report_data'
      this.item_id = id
      this.dialog_open = true
    },
    removePressRelease(id) {
      this.dialog_text = this.$t('instruction.remove_item') + ' ' + this.$t('navigation.press_release') + '?'
      this.dialog_type = 'event_data'
      this.item_id = id
      this.dialog_open = true
    },
    removeMediaCoverage(id) {
      this.dialog_text = this.$t('instruction.remove_item') + ' ' + this.$t('navigation.media_coverage') + '?'
      this.dialog_type = 'news_data'
      this.item_id = id
      this.dialog_open = true
    },
    removeJob(id) {
      this.dialog_text = this.$t('instruction.remove_item') + ' ' + this.$tc('navigation.jobs', 1) + '?'
      this.dialog_type = 'job_data'
      this.item_id = id
      this.dialog_open = true
    },
    removePresentation(id) {
      this.dialog_text = this.$t('instruction.remove_item') + ' ' + this.$t('navigation.presentation') + '?'
      this.dialog_type = 'presentation_data'
      this.item_id = id
      this.dialog_open = true
    },
    removeAnalystCoverage(id) {
      this.dialog_text = this.$t('instruction.remove_item') + ' ' + this.$t('navigation.analyst_coverage') + '?'
      this.dialog_type = 'analyst_coverage_data'
      this.item_id = id
      this.dialog_open = true
    },
    removeInvestorNotices(id) {
      this.dialog_text = this.$t('instruction.remove_item') + ' ' + this.$t('navigation.investor_notices') + '?'
      this.dialog_type = 'investor_relation_notices_data'
      this.item_id = id
      this.dialog_open = true
    },
    async getDialogValue(action) {
      this.dialog_open = false
      if (action) {
        if (this.dialog_type != '' && this.item_id != -1) {
          try {
            let params = new URLSearchParams()

            params.set(
              'delete_data_by_data_type_and_id',
              JSON.stringify({
                id: this.item_id,
                data_type: this.dialog_type,
              }),
            )

            let remove_data = await postData(params)

            this.snack_bar_open = true
            this.snack_bar_text = this.$t('instruction.remove_success')

            setTimeout(() => {
              location.reload()
            }, 2000)
          } catch (error) {
            globalFunc.log(error)
            this.snack_bar_open = true
            this.snack_bar_text = this.$t('instruction.remove_fail')
          }
        }
      }
    },
    updateSnackBar(status) {
      this.snack_bar_open = status
    },
  },
}
</script>

<style>
.v-data-table .v-data-table-header-mobile .v-text-field .v-select__selections {
  margin-top: 0.5rem;
}
.custom-table-toolbar .v-input--selection-controls .v-input__slot > .v-label {
  font-size: 0.875rem;
}
.custom-table-toolbar .v-input input,
.custom-table-toolbar .v-input label {
  font-size: 0.825rem;
}
.v-data-table > .v-data-table__wrapper .v-data-table__mobile-table-row {
  padding-top: 1rem;
}
.v-data-table > .v-data-table__wrapper .v-data-table__mobile-row:last-of-type {
  padding-bottom: 1rem;
}
.v-data-table > .v-data-table__wrapper .v-data-table__mobile-row {
  min-height: 2.2rem;
}
.hide-page-select .v-data-footer__select {
  visibility: none;
  opacity: 0;
  pointer-events: none;
}
.v-dialog.table-dialog {
  margin: 0 auto;
}
</style>
